module.exports = __webpack_public_path__ + "static/img/2021Q3_MC_HONDAONPS.31fc4e8.jpg";